module.exports = __webpack_public_path__ + "img/sms-coupon.ba726ec3.svg";